module.exports = __webpack_public_path__ + "img/4.087a9284.jpg";